import { RouterManager } from '@aclass/admin/managers';
import { PipelineStory } from '@aclass/admin/storage/actions';
import { IAdminState, IPipelineModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class PipelineEditStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:pipeline-edit';

    private id: number;

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IPipelineModuleState['editPageRecordId']>(['pipelineModule', 'editPageRecordId']).pipe(
            filter(v => v === this.id)
        );
        this.employee = this.routerManager.onRejectNavigation(PipelineEditStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(route: ActivatedRouteSnapshot): void {
        this.id = parseInt(route.params.id);
        this.ngRdx.dispatch(PipelineStory.dryRunEditPage(this.id));
    }
}
